import { RelationshipUtils } from '../relationship/relationship-utils';

export function fieldName(field, entity) {
  if (RelationshipUtils.isRelationship(field, entity)) {
    if (field.entityA === entity.id) {
      return field.fieldNameA;
    } else {
      return field.fieldNameB;
    }
  }

  return field.name ? field.name.singular || '' : '';
}
